<template>
  <div :style='mainContainerStyles' :class="{'is-ordering': isOrdering}">

    <div style='position: sticky'>
      <div v-if='isInFormView' style='box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05); height: 64px; padding: 8px 20px; background-color: #fff; display: flex; flex-direction: row; align-items: center; justify-content: center'>
        <div class='home-button-nav' @click='isInFormView = false'>
          <svg width='24px' height='24px' stroke-width='1.5' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' color='#000000'>
            <path d='M15 6l-6 6 6 6' stroke='#000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
          </svg>
        </div>
        <div class='text-m-bold'>{{ addressFormData.id ? 'Editar dirección' : 'Nueva dirección' }}</div>
      </div>

      <div v-else style='box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.05); padding: 8px 20px; background-color: #fff; display: flex; flex-direction: column; align-items: center; justify-content: center'>
        <div style='height: 64px; display: flex; flex-direction: row; align-items: center; justify-content: center'>
          <div v-if='isOrdering && screenWidth > 767' class='home-button-nav-right' @click='handleBackButton'>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="m6 6 12 12m0-12L6 18" stroke="#121212" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div v-else class='home-button-nav' @click='handleBackButton'>
            <svg width='24px' height='24px' stroke-width='1.5' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' color='#000000'>
              <path d='M15 6l-6 6 6 6' stroke='#000000' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' />
            </svg>
          </div>
          <div class='text-m-bold'>Mis direcciones</div>
        </div>
        <div style='display: flex; align-items: center; justify-content: center; width: 100%; gap: 8px;'>
          <InputText
            isOptional
            :maxLength='150'
            placeholder='Busca una dirección'
            v-model='textToFilter'
          />
          <div>
            <ButtonDefinitive
              variant='secondary'
              isIconOnly
              @click='openAddAddress'
            >
              <template v-slot:icon>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12h12m-6-6v12" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </template>
            </ButtonDefinitive>
          </div>
        </div>
      </div>
    </div>

    <div v-if='!isInFormView' :style="bodyStyles">

      <article v-if='addressesList.length === 0' class='empty-registers-container'>
        <svg width='96' height='96' viewBox='0 0 96 96' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M47.997 89.993c28.003 0 41.996-18.802 41.996-41.996S76 6 47.997 6C19.993 6 6 24.803 6 47.997s13.993 41.996 41.997 41.996' fill='#FFC740'/><path d='M39 72a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9' fill='#993438'/><path d='M31.5 57C38.956 57 45 50.956 45 43.5S38.956 30 31.5 30 18 36.044 18 43.5 24.044 57 31.5 57m33 0C71.956 57 78 50.956 78 43.5S71.956 30 64.5 30 51 36.044 51 43.5 57.044 57 64.5 57' fill='#fff'/><path d='M24.208 23.963c-1.778 1.688-2.854 3.72-3.285 5.011a1.5 1.5 0 1 1-2.846-.948c.57-1.71 1.894-4.177 4.066-6.239C24.339 19.702 27.444 18 31.5 18a1.5 1.5 0 0 1 0 3c-3.143 0-5.539 1.298-7.292 2.963M36 51a6 6 0 1 0 0-12 6 6 0 0 0 0 12m24 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12m15.077-22.026c-.43-1.29-1.506-3.323-3.285-5.011C70.04 22.298 67.644 21 64.5 21a1.5 1.5 0 1 1 0-3c4.056 0 7.161 1.702 9.358 3.787 2.171 2.062 3.495 4.53 4.065 6.239a1.5 1.5 0 1 1-2.846.948' fill='#121212'/></svg>
        <div style='text-align: center;'>
          <p class='text-m-regular'>Aún no has</p>
          <p class='text-m-regular'>guardado direcciones</p>
        </div>
        <ButtonDefinitive
          variant='secondary'
          label='+ Nueva dirección'
          @click='openAddAddress'
        />
      </article>

      <div v-else-if='addressesFiltered.length > 0' :class="{'isButtonShowed': true}">
        <div v-for='(address, i) in addressesFiltered' v-bind:key='address.favoriteLocationId'>
          <Address
            :address='address'
            :elKey='i'
            :addressList='addressesFiltered'
            @editAction='openDetailAddress'
            @deleteAction='deleteAddressConfirmation'

            :isOrdering='isOrdering'
            :addressSelectedId='addressSelectedId'
            @handleSelectAddress='selectAddress'
          />
        </div>
        <div
          v-show='addressSelectedId'
          style='position: absolute; margin: auto; bottom: 32px; left: 0; right: 0; width: 85%; transition: .3s'
        >
          <ButtonDefinitive
            label='Recoger de esta dirección'
            @click='confirmAddressSelected'
          />
        </div>
      </div>
      <div v-else class='empty-registers-container'>
        <svg width='96' height='96' viewBox='0 0 96 96' fill='none' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#a)'><path d='M47.997 89.993c28.003 0 41.996-18.802 41.996-41.996S76 6 47.997 6C19.993 6 6 24.803 6 47.997s13.993 41.996 41.997 41.996' fill='#FFC740'/><path d='M45 43.5C45 50.956 38.956 57 31.5 57S18 50.956 18 43.5 24.044 30 31.5 30 45 36.044 45 43.5m33 0C78 50.956 71.956 57 64.5 57S51 50.956 51 43.5 57.044 30 64.5 30 78 36.044 78 43.5' fill='#fff'/><path d='M33 54a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9m30 0a9 9 0 0 0 9-9 9 9 0 0 0-9-9 9 9 0 0 0-9 9 9 9 0 0 0 9 9' fill='#121212'/><path d='M96 0H0v96h96zM66.444 16.314l3.713 2.167-.501 5.362a21.07 21.07 0 0 0 9.957 7.821l2.912-1.313 1.531 2.444A26 26 0 0 0 84 34.5c0 4.136.985 8.042 2.733 11.497l-.686 3.45-2.99 1.07A16.4 16.4 0 0 0 81 58.5q0 1.183.162 2.322a21.05 21.05 0 0 0-13.813 12.755 25.4 25.4 0 0 0-8.113-1.567C57.386 66.762 52.382 63 46.5 63c-4.268 0-8.073 1.98-10.547 5.072C31.557 63.12 25.143 60 18 60h-.067a16.5 16.5 0 0 0-6.808-11.903l-2.933.293-.723-2.277C12.072 42.26 15 36.473 15 30q0-.225-.005-.451l2.742-1.437s2.59 1.877 3 1.855c6.873-.373 12.926-3.83 16.798-9.011l1.196-6.785 3.23-5.336C45.408 14.34 51.527 18 58.5 18c2.829 0 5.517-.602 7.944-1.686' fill='#FBFBFF'/><path d='M0 56.13v-6a21 21 0 0 0 7.469-4.017 16.5 16.5 0 0 1 3.684 2.004A21.04 21.04 0 0 1 0 56.13m0 30.803v-9q.741.066 1.5.067c5.576 0 10.506-2.765 13.492-7C14.742 79.38 8.246 86.19 0 86.933M33.042 96h-7.923a25.5 25.5 0 0 1 5.454-9.59 13.5 13.5 0 0 1-.575-3.91c0-3.382 1.244-6.475 3.3-8.843-.196.916-.3 1.868-.3 2.843 0 3.308 1.19 6.338 3.165 8.686A25.35 25.35 0 0 0 33.042 96m58.835 0h-7.923a25.4 25.4 0 0 0-7.143-16.245A25.57 25.57 0 0 1 91.877 96M96 74.933v5.446a16.53 16.53 0 0 1-11.455-11.66A16.48 16.48 0 0 0 96 74.933m.002-18.795v7.607a25.6 25.6 0 0 1-12.951-13.213 16.6 16.6 0 0 1 3.684-4.534 25.6 25.6 0 0 0 9.267 10.14M39.407 2.484A19.4 19.4 0 0 0 36 13.5c0 2.66.532 5.196 1.497 7.506a22.4 22.4 0 0 0 4.464-12.17 19.4 19.4 0 0 1-2.554-6.352m35.537 6.504a19.6 19.6 0 0 1-8.499 7.326 20.9 20.9 0 0 0 3.24 7.569A19.43 19.43 0 0 0 75.001 10.5q0-.763-.058-1.512m13.776 10.73a25.57 25.57 0 0 0-9.143 11.932c1.426.54 2.925.927 4.48 1.145.32-4.856 2-9.34 4.663-13.077m-73.721 9.831a22.6 22.6 0 0 0 5.787.415c-1.168-8.063-6.916-14.642-14.521-17.015 5.179 3.731 8.59 9.764 8.734 16.6' fill='#CDB6FB'/></g><defs><clipPath id='a'><path fill='#fff' d='M0 0h96v96H0z'/></clipPath></defs></svg>
        <div style='text-align: center;'>
          <p class='text-m-regular'>No encontramos</p>
          <p class='text-m-regular'>esa dirección</p>
        </div>
      </div>

    </div>

    <div v-else class='form_view' style='background-color: #FBFBFF; flex: 1; overflow-y: auto'>
      <div v-show='!isOrdering' style='margin: -12px 0 4px -12px'>
        <CustomRadioButton
          radioId='1'
          :inputValue='1'
          v-model='addressFormData.addressType'
          label='Domicilio'
        />
        <CustomRadioButton
          radioId='2'
          :inputValue='2'
          v-model='addressFormData.addressType'
          label='Punto Sharf'
        />
      </div>
      <div v-show='addressFormData.addressType === 1' style='display: flex; flex-direction: column; gap: 16px'>
        <CustomSearchSelect
          v-model='addressFormData.districtId'
          ref='CustomSelectDistrictRef'
          @setSelectedDisctrict='setAddressComplement'
          :repoSearch='getScharffDistrics'
          label='Distrito'
          placeholder='Busca un distrito'
          errorMessage='Ingresa un distrito y selecciona uno de los resultados sugeridos.'
          :showEmptyInputError='tryToSaveAddressData && !addressFormData.districtId'
        />
        <InputText
          label='Dirección'
          :maxLength='150'
          placeholder='Calle, número, dpto.'
          v-model='addressFormData.address'
          missingErrorMessage='Ingresa una dirección.'
          :showEmptyInputError='tryToSaveAddressData && !addressFormData.address'
        />
        <InputText
          label='Referencia (opcional)'
          :maxLength='150'
          isOptional
          placeholder=''
          v-model='addressFormData.additionalAddress'
        />
        <InputText
          label='Etiqueta (opcional)'
          :maxLength='150'
          isOptional
          placeholder='Casa, almacén, oficina, sede central'
          v-model='addressFormData.tag'
        />
        <div v-if="isOrdering && action === 'store'" style='padding-top: 16px;'>
          <CustomCheckbox
            checkboxId='save-address'
            v-model="saveAddress"
            label="Guardar en mi lista de direcciones."
          />
        </div>
        <div style='padding-top: 16px;'>
          <CustomCheckbox
            checkboxId='fragile-product'
            v-model='addressFormData.isPredetermined'
            label='Establecer como dirección de origen predeterminada.'
          />
        </div>
      </div>
      <div v-show='addressFormData.addressType === 2'>
        <CustomSearchSelect
          v-model='addressFormData.originPointId'
          ref='CustomSelectPointsRef'
          @setSelectedDisctrict='setPointData'
          :repoSearch='getScharffPoints'
          :isPoint=true
          label='Punto Sharf'
          placeholder='Busca por nombre o distrito'
          errorMessage='Ingresa un distrito o el nombre de un Punto Sharf y selecciona uno de los resultados sugeridos.'
          :showEmptyInputError='tryToSaveAddressData && !addressFormData.originPointId'
        />
        <div style='padding-top: 32px'>
          <CustomCheckbox
            checkboxId='fragile-product'
            v-model='addressFormData.isPredetermined'
            label='Establecer como punto de origen predeterminado.'
          />
        </div>
      </div>
      <div style='padding-top: 16px;'>
        <ButtonDefinitive
          :label='buttonLabel'
          @click='validateForm'
        />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonDefinitive from '../components/Button/ButtonDefinitive.vue'
import CustomRadioButton from '../components/Form/CustomRadioButton.vue'
import InputText from '../components/Form/InputText.vue'
import CustomCheckbox from '../components/Form/CustomCheckbox.vue'
import ErrorMessage from '../components/ErrorMessage.vue'
import { deleteFavoriteLocation } from '../services/client'
import { getScharffDistrics, getScharffPoints } from '../services/fare'
import CustomSearchSelect from '../components/Form/CustomSearchSelect.vue'
import Address from '../components/Favorites/Address.vue'

export default {
  name: 'AddressView',
  // title: 'Direcciones - Scharff',
  components: {
    ButtonDefinitive,
    CustomRadioButton,
    InputText,
    CustomCheckbox,
    ErrorMessage,
    CustomSearchSelect,
    Address
  },
  props: {
    isOrdering: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isInFormView: false,
      addressFormData: {
        id: '',
        addressType: 1,
        districtId: '',
        address: '',
        additionalAddress: '',
        tag: '',
        isPredetermined: false,
        originPointId: ''
      },
      tryToSaveAddressData: false,
      action: '',
      textToFilter: '',
      lessThanNineDigitsFlag: false,

      addressSelectedId: 0,
      addressSelected : {},
      saveAddress: false,

      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      screenHeight2: document.documentElement.clientHeight,
    }
  },
  methods: {
    getScharffDistrics, getScharffPoints,
    handleResize() {
      this.screenWidth = window.innerWidth
      this.screenHeight = window.innerHeight
      this.screenHeight2 = document.documentElement.clientHeight
    },
    selectAddress(addressId) {
      this.addressSelectedId = addressId
      this.addressSelected = this.addressesList.find(address => address.favoriteLocationId === addressId)
    },
    confirmAddressSelected() {
      this.$emit('getFavoriteAddress', this.addressSelected)
      this.isInFormView = false
    },
    handleBackButton() {
      if (this.isOrdering) return this.$emit('handleGoBackButton')
      window.location.href = process.env.VUE_APP_WEBURL
    },
    async fetchAddresses() {
      this.showLoading()
      this.tryToSaveAddressData = false
      try {
        const resp = await this.$store.dispatch('GET_FAVORITE_LOCATIONS')
        this.isInFormView = false
        this.resetFormAddressData()
      } catch (e) {
        console.log({ e })
        const msg = e?.data?.message || 'Ocurrió un error.'
        this.showError(msg)
      } finally {
        this.$swal.close()
      }
    },
    async deleteAddressConfirmation(address) {
      const response = await this.$swal({
        title: 'Confirme',
        html: '¿Desea eliminar esta dirección de favoritos?',
        icon: 'question',
        confirmButtonText: 'Aceptar',
        showDenyButton: true,
        denyButtonText: 'Cancelar'
      })
      if (response.isConfirmed) this.deleteAddress(address.favoriteLocationId)
    },
    async deleteAddress(addressId) {
      this.showLoading()
      await deleteFavoriteLocation(addressId)
      this.$swal.close()
      this.fetchAddresses()
    },
    validateForm() {
      const {
        addressType, address, additionalAddress,
        districtId, tag, isPredetermined, originPointId,
        departmentName, provinceName, districtName
      } = this.addressFormData

      this.tryToSaveAddressData = true
      if (addressType === 1 && (!address || !districtId)) return
      if (addressType === 2 && !originPointId) return

      const payload = {
        address: address,
        addressAditional: additionalAddress,
        distrito: districtId,
        name: addressType === 2 ? 'Punto Sharf' : tag,
        isPredetermined: isPredetermined,
        puntoScharffId: originPointId
      }

      if (this.isOrdering) {
        payload.favoriteLocationId = null
        payload.departmentName = departmentName
        payload.provinceName = provinceName
        payload.districtName = districtName
        this.addressSelected = payload

        this.confirmAddressSelected()
        if (!this.saveAddress && this.action === 'store') return this.resetFormAddressData()
      }

      if(this.action === 'update') {
        payload.favoriteLocationId = this.addressFormData.id
        this.saveChangesAddress(payload)
      }
      if(this.action === 'store') {
        this.storeNewAddress(payload)
      }
    },
    storeNewAddress(payload) {
      this.showLoading('Guardando dirección...')
      this.$store.dispatch('POST_FAVORITE_ADDRESS', payload)
        .then(success => {
          this.$swal.close()
          if (success.status !== 200) this.showError(success.data.message)
          this.fetchAddresses()
        })
        .catch(error => {
          const msg = error?.data?.message || 'Ocurrió un error.'
          this.showError(msg)
        })
    },
    saveChangesAddress(payload) {
      this.showLoading('Guardando dirección...')
      this.$store.dispatch('PUT_FAVORITE_ADDRESS', payload)
        .then(success => {
          this.$swal.close()
          if (success.status !== 201) {
            this.showError(success.data.message)
            this.fetchAddresses()
          }
        })
        .catch(error => {
          const msg = error?.data?.message || 'Ocurrió un error.'
          this.showError(msg)
        })
    },
    openAddAddress() {
      this.action = 'store'
      this.isInFormView = true
      this.resetFormAddressData()
    },
    openDetailAddress(address) {
      this.isInFormView = true
      this.action = 'update'
      this.addressFormData = {
        id: address.favoriteLocationId,
        addressType: address.addressType,
        address: address.address,
        additionalAddress: address.addressAditional || '',
        tag: address.name,
        isPredetermined: address.isPredetermined,
        originPointId: address.puntoScharffId,
        departmentName: address.departmentName,
        provinceName: address.provinceName,
        districtName: address.districtName,
      }
      setTimeout(() => {
        if (address.addressType === 1) {
          this.$refs.CustomSelectDistrictRef.selectElementFromOutside({
            textToFinded: address.districtName,
            id: address.distrito
          })
        }
        if (address.addressType === 2) {
          this.$refs.CustomSelectPointsRef.selectElementFromOutside({
            textToFinded: address.puntoScharffName,
            id: address.puntoScharffId
          })
        }
      }, 20)
    },
    setPointData(point) {
      this.addressFormData.address = point.address
      this.addressFormData.tag = point.name
    },
    setAddressComplement(extraAddressData) {
      try {
        const [dpto, prov, dist] = extraAddressData.text.split(' - ')
        this.addressFormData.departmentName = dpto
        this.addressFormData.provinceName = prov
        this.addressFormData.districtName = dist
      } catch (e) {
        console.log(e)
      }
    },
    resetFormAddressData() {
      this.addressFormData = {
        id: '',
        addressType: 1,
        districtId: '',
        address: '',
        additionalAddress: '',
        tag: '',
        isPredetermined: false,
        originPointId: ''
      }
    }
  },
  mounted() {
    this.$nextTick(async () => {
      this.$store.dispatch('STYLE_MAP_SAIO', false)
      this.closeSidebar();
      this.$store.dispatch('STYLE_CUSTOM_DIV', process.env.VUE_APP_STYLE_HOME_FAVORITES)
      if (!this.isOrdering) {
        this.fetchAddresses()
        document.title = 'Direcciones - Sharf'
      }
    })

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    addressesList() { return this.$store.getters.GENERAL_FAVORITE_ADDRESSES },
    addressesFiltered() {
      let addressesList = this.addressesList
      if (this.isOrdering) {
        addressesList = this.addressesList.filter(address => !address.puntoScharffId)
      }
      if (!this.textToFilter) return addressesList
      return addressesList.filter(address => address.address.toLowerCase().includes(this.textToFilter.toLowerCase()))
    },
    mainContainerStyles() {
      const styles = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden'
      }
      return styles
    },
    buttonLabel() {
      if (!this.isOrdering) return 'Guardar'

      if (this.addressFormData.id) return 'Confirmar y guardar'

      if (this.saveAddress) {
        return `Guardar y recoger de esta dirección`
      } else {
        return `Recoger de esta dirección`
      }
    },
    bodyStyles() {
      const styles = {
        backgroundColor: '#FFF',
        overflowY: 'auto',
        height: '100%'
      }

      // Solo hay ese padding cuando sea celular, las barras del navegador estén visibles y no este generando pedido
      if (
        this.screenWidth < 767 &&
        (this.screenHeight === this.screenHeight2) &&
        !this.isOrdering
      ) {
        styles.paddingBottom = '200px'
      }
      return styles
    }
  },
  watch: {
    'addressFormData.isPredetermined'(newValue) {
      if (newValue && this.isOrdering) {
        this.saveAddress = true
      }
    },
    saveAddress(newValue) {
      if (!newValue && this.isOrdering) {
        this.addressFormData.isPredetermined = false
      }
    },
    '$store.getters.PROGRAMMED_ORDER_ORIGIN_FAVORITE_ID': function(val) {
      this.addressSelectedId = val || 0
    },
    '$store.getters.SCHARFFPOINT_ORDER_ORIGIN_FAVORITE_ID': function(val) {
      this.addressSelectedId = val || 0
    }
  },
}
</script>

<style scoped lang='scss'>
  .empty-registers-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  .form_view {
    padding: 32px 16px 32px 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .isButtonShowed {
    padding-bottom: 112px;
  }

  
  .is-ordering{
    @media (min-width: 767px) {
      height: 80vh !important;
    }
  }
</style>